import { useCreateTrigger } from 'hooks/business/useTrigger';
import { Dispatch, SetStateAction } from 'react';
import createNamedContext from 'utils/createNamedContext';

export type HelpStep =
  | '促销类型'
  | '活动名称'
  | '活动生效期'
  | '活动预热期'
  | '适用店铺'
  | '适用商品'
  | '最高折扣'
  | '活动卖点'
  | '专属销售方案';

type UseState<T> = [T, Dispatch<SetStateAction<T>>];

export interface HelpContextValue {
  inline: boolean;
  displayState: UseState<boolean>;
  hiddedState: [boolean, ReturnType<typeof useCreateTrigger>];
  stepState: UseState<HelpStep>;
  stepTitleMap: Record<HelpStep, string>;
  stepContentMap: Record<HelpStep, string>;
  getStepTitleMap: (activityType?: Knowledge.Activity.Type) => Record<HelpStep, string>;
}

export const HelpContext = createNamedContext<HelpContextValue | null>('HelpContext', null);
